import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    configs: {},
    account: {},
    drivers: [],
    moment,
  },
  mutations: {
    setState (state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    fetchConfigs ({ dispatch }) {
      return $.when(
        dispatch('fetchState', 'configs'),
        dispatch('fetchState', 'account'),
      );
    },
    fetchState ({ commit }, type) {
      return $.get(`/api/${type}`).then(({ data }) => {
        commit('setState', {
          type,
          data: type === 'configs' ? data : data[type],
        });
      });
    },
  },
  getters: {
    getCurrencyObject: state => isoCode => state.configs.supported_currencies.find(currency => currency.iso_code === isoCode),
  },
});
